// extracted by mini-css-extract-plugin
module.exports = {"surveyRatingOptions":"styles-module__surveyRatingOptions___1FQqE","legends":"styles-module__legends___1KTH2"};